import React from 'react';

import LastEditorInfo from '../../../app/components/LastEditorInfo';
import Button from '../../../common/components/Button/Button';
import { usePokCore } from '../../../common/hooks/usePokCore';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface SpecialInvoicingControlsProps {
  id?: string;
  readOnly?: boolean;
  handleSave: () => Promise<void>;
  handleDeactivate?: () => Promise<void>;
  isLoadingSave: boolean;
  isLoadingDeactivate?: boolean;
}

export const SpecialInvoicingControls: React.FC<
  SpecialInvoicingControlsProps
> = props => {
  const id = props.id && props.id !== 'utworz' ? props.id : undefined;
  const pok = usePokCore();
  const { t, tk } = useTranslation('applicationLng');

  return (
    <div className="d-flex justify-content-between align-items-center w-100">
      {id && (
        <LastEditorInfo
          id={id}
          className="color-primary"
          method={pok.specialInvoicing.getLastEditor}
        />
      )}
      <div className="d-flex marginLeft gap-2">
        {!props.readOnly && props.id && props.handleDeactivate && (
          <ConfirmationButton
            className="mx-1"
            confirmation={t(tk.app.askDeleteApplication)}
            variant="outline-danger"
            onOK={props.handleDeactivate}
            isLoading={props.isLoadingDeactivate}
            disabled={props.isLoadingSave}
          >
            {t(tk.button.delete)}
          </ConfirmationButton>
        )}
        {!props.readOnly && (
          <Button
            variant="primary"
            onClick={props.handleSave}
            isLoading={props.isLoadingSave}
            disabled={props.isLoadingDeactivate}
          >
            {t(tk.button.save)}
          </Button>
        )}
      </div>
    </div>
  );
};
